import React from 'react';
import './../Style/NEETCutoff2027.css';
import TopNavbar from '../../../home/TopNavbar';
import TopHeader from '../../../home/TopHeader';

const NEETCutoff2027 = () => {
  // Data structure for NEET 2027 Expected Cutoff
  const expectedCutoff2027 = [
    { category: 'General', percentile: '50th', marks: '720 – 135' },
    { category: 'OBC', percentile: '40th', marks: '134 – 108' },
    { category: 'SC', percentile: '40th', marks: '134 – 108' },
    { category: 'ST', percentile: '40th', marks: '134 – 108' },
    { category: 'General-PwD', percentile: '45th', marks: '134 – 120' },
  ];

  // Data structure for NEET 2026 Cutoff
  const cutoff2026 = [
    { category: 'UR/EWS', percentile: '50th percentile', marks: '715–213' },
    { category: 'OBC', percentile: '40th percentile', marks: '212–177' },
    { category: 'SC', percentile: '40th percentile', marks: '212–177' },
    { category: 'ST', percentile: '40th percentile', marks: '212–177' },
    { category: 'UR/EWS-PwBD', percentile: '45th percentile', marks: '212–194' },
    { category: 'OBC-PwBD', percentile: '40th percentile', marks: '193–177' },
    { category: 'SC-PwBD', percentile: '40th percentile', marks: '193–177' },
    { category: 'ST-PwBD', percentile: '40th percentile', marks: '191–178' },
  ];

  // Data structure for NEET 2025 Cutoff
  const cutoff2025 = [
    { category: 'General', percentile: '50th', marks: '720 – 137' },
    { category: 'OBC', percentile: '40th', marks: '136 – 107' },
    { category: 'SC', percentile: '40th', marks: '136 – 107' },
    { category: 'ST', percentile: '40th', marks: '136 – 107' },
    { category: 'General-PwD', percentile: '45th', marks: '136 – 121' },
  ];

  // Data structure for NEET 2024 Cutoff
  const cutoff2024 = [
    { category: 'General', percentile: '50th', marks: '720 – 137' },
    { category: 'OBC', percentile: '40th', marks: '136 – 107' },
    { category: 'SC', percentile: '40th', marks: '136 – 107' },
    { category: 'ST', percentile: '40th', marks: '136 – 107' },
    { category: 'General-PwD', percentile: '45th', marks: '136 – 121' },
  ];

  return (
    <div className="neetcutoff-container">
     
     <TopNavbar name="NEET Cutoff" ></TopNavbar>
     <TopHeader name="NEET Cutoff" ></TopHeader>

      {/* Main Content Area */}
      <main className="neetcutoff-content">
        <h2 className="neetcutoff-main-heading">NEET 2027 : Cutoff</h2>

        <p className="neetcutoff-description">
          The <strong>NEET cutoff</strong> is the minimum score required to qualify for the next stage of admission to MBBS, BDS, and other medical courses in India. The cutoff varies every year based on the difficulty level of the exam, number of candidates, and seat availability.
        </p>

        <p className="neetcutoff-description">
          The <strong>NTA</strong> releases category-wise cutoff marks along with the results. Candidates must score equal to or above the cutoff to qualify for the NEET counselling process.
        </p>

        {/* Section: Expected Cutoff 2027 */}
        <section className="neetcutoff-section">
          <h3 className="neetcutoff-section-title">
            NEET 2027 Expected Cutoff (Qualifying Percentile &amp; Marks)
          </h3>
          <div className="neetcutoff-table-wrapper">
            <table className="neetcutoff-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Qualifying Percentile</th>
                  <th>Expected Cutoff Marks (2027)</th>
                </tr>
              </thead>
              <tbody>
                {expectedCutoff2027.map((item, index) => (
                  <tr key={index}>
                    <td className="neetcutoff-td-category">{item.category}</td>
                    <td className="neetcutoff-td-percentile">{item.percentile}</td>
                    <td className="neetcutoff-td-marks">{item.marks}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Section: Previous Year Cut Off */}
        <section className="neetcutoff-section">
          <h2 className="neetcutoff-sub-heading">Previous Year NEET UG Cut Off</h2>

          {/* 2026 Cutoff */}
          <div className="neetcutoff-subsection">
            <h3 className="neetcutoff-section-title">
              NEET 2026 Cutoff (Qualifying Percentile &amp; Marks)
            </h3>
            <div className="neetcutoff-table-wrapper">
              <table className="neetcutoff-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Qualifying Percentile</th>
                    <th>NEET UG 2026 Cutoff Marks</th>
                  </tr>
                </thead>
                <tbody>
                  {cutoff2026.map((item, index) => (
                    <tr key={index}>
                      <td className="neetcutoff-td-category">{item.category}</td>
                      <td className="neetcutoff-td-percentile">{item.percentile}</td>
                      <td className="neetcutoff-td-marks">{item.marks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* 2025 Cutoff */}
          <div className="neetcutoff-subsection">
            <h3 className="neetcutoff-section-title">
              NEET 2025 Cutoff (Qualifying Percentile &amp; Marks)
            </h3>
            <div className="neetcutoff-table-wrapper">
              <table className="neetcutoff-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Qualifying Percentile</th>
                    <th>Cutoff Marks (2025)</th>
                  </tr>
                </thead>
                <tbody>
                  {cutoff2025.map((item, index) => (
                    <tr key={index}>
                      <td className="neetcutoff-td-category">{item.category}</td>
                      <td className="neetcutoff-td-percentile">{item.percentile}</td>
                      <td className="neetcutoff-td-marks">{item.marks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* 2024 Cutoff */}
          <div className="neetcutoff-subsection">
            <h3 className="neetcutoff-section-title">
              NEET 2024 Cutoff (Qualifying Percentile &amp; Marks)
            </h3>
            <div className="neetcutoff-table-wrapper">
              <table className="neetcutoff-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Qualifying Percentile</th>
                    <th>Cutoff Marks (2024)</th>
                  </tr>
                </thead>
                <tbody>
                  {cutoff2024.map((item, index) => (
                    <tr key={index}>
                      <td className="neetcutoff-td-category">{item.category}</td>
                      <td className="neetcutoff-td-percentile">{item.percentile}</td>
                      <td className="neetcutoff-td-marks">{item.marks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Note Box */}
        <div className="neetcutoff-note-card">
          <p>
            <strong>Note:</strong> The cutoff for government medical colleges is usually much higher than the qualifying cutoff. For top colleges, a general category candidate often needs 630+ marks.
          </p>
        </div>
      </main>

   
    </div>
  );
};

export default NEETCutoff2027;